import React, { useState, useEffect, Fragment } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import { configStyle, obtenerValorConfig, replaceValue, obtenerValorUser } from '../services/configStyle'
import Header from "../components/headerNA";
import Footer from "../components/footer";
import { withOrientationChange } from 'react-device-detect';
import { actualizarEstado } from '../services/api.js';
import {status, statusError, statusData} from '../services/data'

let ValidacionDocumento = (props) => {
    const history = useHistory();
    const [dataOtorgante, setDataOtorgante] = useState([])
    const [showCancel, setShowCancel] = useState(false)
    const [apiKey, setApiKey] = useState('')
    const [uuid, setUuid] = useState('')
    const [dataOCRFront, setDataOCRFront] = useState({})
    const [nombre, setNombre] = useState('')
    const [dataUser, setDataUser] = React.useState([])
    const { isLandscape } = props;

    useEffect(() => {
        let apikeyOtorgante = localStorage.getItem("apikeyOtorgante")
        if (apikeyOtorgante !== null) {
            setApiKey(apikeyOtorgante)
        }
        let uuidUser = localStorage.getItem("uuidUser")
        if (uuidUser != null) {
            setUuid(uuidUser)
        }
        let dataUserLS = localStorage.getItem("data_user")
        if (dataUserLS != null) {
            setDataUser(JSON.parse(dataUserLS))
        }
        let dataOCRFrontLS = localStorage.getItem("ocrFront")
        if (dataOCRFrontLS != null) {
            const ocrFront = JSON.parse(dataOCRFrontLS)
            setDataOCRFront(ocrFront)
        }
        let dataOtorganteLS = localStorage.getItem("dataOtorgante")
        if (dataOtorganteLS != null) {
            setDataOtorgante(JSON.parse(dataOtorganteLS))
        }
        let bloqueo = localStorage.getItem("bloqueo");

        let newDate = new Date().getTime()
        if (bloqueo === 'true') {

            if (newDate >= localStorage.getItem("time")) {
                localStorage.setItem("bloqueo", false);
                localStorage.setItem("time", 0);

            }
        }
        //console.log(uuid,dataOCRFront);
        status("documento_clausulas_page", "Documento Cláusula")
    }, [])

    useEffect(() => {
        localStorage.setItem("data_user", JSON.stringify(dataUser))
        setNombre(obtenerValorUser(dataUser, "nombre", ""))
    }, [dataUser])

    useEffect(() => {
        configStyle(dataOtorgante);
    }, [dataOtorgante]);

    const aceptarTerminos = check => {
        setDataUser([...dataUser, { description: "req_elec_acepted", value: check }]);
        if (check) {
            let data = { documento_clausulas_aceptado: true}
            statusData("documento_clausulas",  data)
            setTimeout(() => {
                if(obtenerValorConfig(dataOtorgante, 'ENABLE_CONSENTIMIENTO_3', "true") === "true"){
                    history.push("/autorizacion_solicitud");
                }else{
                    history.push("/video_token");
                }
            }, 1000);
        }
    };

    const printText = () => {
        let textToPrint = "";
        let textStorage = obtenerValorConfig(dataOtorgante, "TEXTO_DE_CONSENTIMIENTO_2")
        textToPrint = replaceValue(textStorage, "{USUARIO}", nombre)
        textToPrint = replaceValue(textToPrint, "{OTORGANTE}", obtenerValorConfig(dataOtorgante, "RAZON_SOCIAL"))

        if (textToPrint) {
            return textToPrint.split("{enter}").map(line => {
                return (<Fragment>{line} <br /></Fragment>);
            });
        } else {
            return textToPrint;
        }
    }
    
      const statusE = () => {
        //console.log("entre a status cancelar");
        let data = "Cancelado"
        statusError("Cláusula", data, "cancelado")
        setTimeout(() => {
            window.close()
          }, 300);
      }

    return (
        <Fragment>
            {(showCancel) ?
                <div className="modal fade show" style={{ display: "block" }} role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Cancelar proceso</h5>
                                <button onClick={e => setShowCancel(false)} className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>En este momento se cancelará el proceso, ningún dato será guardado y perderás el avance, esta acción no podrá deshacerse <br /> ¿Deseas cancelar?</p>
                            </div>
                            <div className="modal-footer">
                                <button onClick={e => setShowCancel(false)} className="btn btn-secondary modal_btn_w" data-dismiss="modal">NO</button>
                                <button type="button" onClick={e=>statusE()} className="btn btn-raised btn-secondary modal_btn_w">SI</button>
                            </div>
                        </div>
                    </div>
                </div> : ("")}
            <div className="main_gradient">
                {(obtenerValorConfig(dataOtorgante, "REQ_MEDIOS_ELECTRONICOS", "VERDADERO") === "FALSO") ? <Redirect to="/autorizacion_solicitud" /> : ""}
                <Header ruta="validacion_documento" />
                <h5 className="left-align margin_4 text-color">
                    <b>{(obtenerValorConfig(dataOtorgante, "TITULO_DEL_CONSENTIMIENTO_2", "FALSO") === "FALSO") ? ("") : obtenerValorConfig(dataOtorgante, "TITULO_DEL_CONSENTIMIENTO_2")}</b>
                </h5>
                <div className="terms_container">
                    <div className="terms_bg_box">
                        <p align="left" className="left-align">
                            <h6 className="text-right text-small text-strong">
                                <small>
                                    <strong>
                                        {(obtenerValorConfig(dataOtorgante, "LUGAR_Y_FECHA_CONSENTIMIENTO_2", "FALSO") === "FALSO") ? ("") : (<Fragment>{obtenerValorConfig(dataOtorgante, "CIUDAD_LEGAL_DEL_OTORGANTE")} a {new Intl.DateTimeFormat("es-MX", {
                                            year: "numeric",
                                            month: "long",
                                            day: "2-digit"
                                        }).format(new Date())}</Fragment>)}
                                    </strong>
                                </small>
                            </h6>

                            {printText()}
                        </p>
                        <div className="terms_bg_box_gradient"></div>
                    </div>
                </div>
                <div className="check_container">
                    <form>
                        <div className="checkbox">
                            <label htmlFor="check_terms">
                                <input id="check_terms" type="checkbox" onChange={e => aceptarTerminos(e.target.checked)} />
                                <span className="checkbox-decorator"><span className="check"></span></span>
                                He leído y acepto "{obtenerValorConfig(dataOtorgante, "TITULO_DEL_CONSENTIMIENTO_2")}".
                        </label>
                        </div>
                    </form>
                </div>
                <br/>
                <br/>
                <br/>
                <Footer />
            </div>
            <div className={(showCancel ? "modal-backdrop show" : "")}></div>
            {
                (isLandscape) ? (
                    <div className="rotate_device">
                        <div className="center_info_bx">
                            <img src="images/rotate_device.svg" height="100" alt="" />
                            <p>Por favor usa tu dispositivo en vertical<br />
                                <small>Gira tu dispositivo para continuar</small>
                            </p>
                        </div>
                    </div>
                ) : ("")
            }

            {(localStorage.getItem("bloqueo") === 'true') ? (<div className="err_finale  animated slideInUp">
                <div className="center_checks">
                    <h5>Proceso no exitoso</h5>
                    <p>Haz superado el número <b>máximo</b> de intentos para este proceso inténtalo nuevamente <b>más tarde</b>.</p>
                    <p>Si deseas mayor información no dudes en contactarnos con el <b>Folio</b> de proceso <b>{localStorage.getItem("uuidUser")}</b> </p>
                    <br />
                    <div className="action_buttons noscroll_screen">
                        <Link to={"/" + localStorage.getItem("apikeyOtorgante")} className="btn btn-raised btn-primary forcewidth100 main_bg_color">ENTENDIDO</Link>
                    </div>
                </div>
            </div>) : ("")}
        </Fragment>
    )
}
ValidacionDocumento = withOrientationChange(ValidacionDocumento)
export default ValidacionDocumento